import React, { useState, useEffect } from "react";
import styles from "../../styles/components/documentUploader.module.scss";
import Icons from "../../public/assets/svg";
import UploadDocument from "../../components/uploadFile/index";
import { BlobServiceClient} from "@azure/storage-blob";
import Fuse from "fuse.js";
import endpoints from '../../utility/endpoints'

const ModalExample = (props) => {
  const [uploaded, setUploaded] = useState({});
  const [couldNotUpload, setCouldNotUpload] = useState({});
  const [totalItems, setTotalItems] = useState(null);
  const [uploadedItems, setUploadedItems] = useState(0);
  const [originalFileNames, setOriginalFileNames] = useState({});
  const [azureFileNames, setAzureFileNames] = useState({});
  
  const blobSasUrl =
    "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin";
  const blobSasUrlNew = endpoints.blobSasUrlNew
//   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";

const blobSasUrl1=endpoints.blobSasUrl

  const blobServiceClient = new BlobServiceClient(blobSasUrlNew);
  const containerClient = blobServiceClient.getContainerClient(`botstorevideo/${props.documentFolderName}`);


  // const createContainer = async () => {
  //   try {
  //     // reportStatus(`Creating container "${containerName}"...`);
  //     await containerClient.create();
  //     console.log("done");
  //     // reportStatus(`Done.`);
  //   } catch (error) {
  //     console.log(error);
  //     // reportStatus(error.message);
  //   }
  // };

  // createContainer()
  /**
 *

   
 */

  React.useEffect(() => {
    if (props.uploadedDocumentsState != null) {
      console.log(
        "consoling em down ",
        props.uploadedDocumentsState,
        "dsada",
        props.uploadedDocumentsState.uploaded,
        props.uploadedDocumentsState.totalItems,
        props.uploadedDocumentsState.uploadedItems,
        props.uploadedDocumentsState.originalFileNames
      );
      setUploaded(props.uploadedDocumentsState.uploaded);
      setTotalItems(props.uploadedDocumentsState.totalItems);
      setUploadedItems(props.uploadedDocumentsState.uploadedItems);
      setOriginalFileNames(props.uploadedDocumentsState.originalFileNames);
      setAzureFileNames(props.uploadedDocumentsState.azureFileNames);
    }
  }, []);

  let documentAr = [
    { title: "SOP", value: "sopDocument", type: [".pdf",".doc",".docx", ".msg", ".png", ".jpeg", ".jpg", ".xls", ".xlsx", ".ppt", ".pptx"] },
    { title: "PDD", value: "pddDocument", type: [".pdf",".doc",".docx"] },
    { title: "PDD Approval", value: "pddApprovalDocument", type: [".msg",".png"] },
    { title: "SDD", value: "sddDocument", type: [".pdf",".doc",".docx"] },
    { title: "QSG", value: "qsgDocument", type: [".doc",".docx"] },
    { title: "ODI", value: "odiDocument", type: [".xlxs",".xls"] },
    { title: "BRD", value: "brdDocument", type: [".xlxs",".xls"] },
    {
      title: "Cost Apporval",
      value: "costApprovalDocument",
      type:  [".msg",".png"],
    },
    {
      title: "Landscape Approval",
      value: "explicitLandscapeApplicationOwnerApprovalDocument",
      type: ".msg",
    },
    {
      title: "GPM Approval",
      value: "explicitGPMApprovalSupplyChainFinanceDocument",
      type: [".msg",".png"],
    },
    {
      title: "GFCF Approval",
      value: "explicitGFCFApprovalDocument",
      type: [".msg",".png"],
    },
    {
      title: "Dev Quality Crendentails Available",
      value: "devQualityCredentialsAvailableDocument",
      type: ".msg",
    },
    {
      title: "Infosec Approval",
      value: "infosecApprovalDocument",
      type: ".msg",
    },
    {
      title: "DA Review Sign Off",
      value: "dAReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "Test Data Development",
      value: "testDataAvailableForDevelopmentDocument",
      type: [".xlxs",".xls"],
    },
    {
      title: "Request Raised Product Credentials",
      value: "requestRaisedForProductionCredentialsDocument",
      type: ".msg",
    },
    {
      title: "Internal Testing Completed",
      value: "internalTestingCompletedDocument",
      type: ".msg",
    },
    {
      title: "Peer Review Sign Off",
      value: "peerReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "DA Review Second Sign Off",
      value: "daReviewSecondSignOffDocument",
      type: ".msg",
    },
    {
      title: "BP Release Sign Off",
      value: "bpReleaseSignOffFromDaDocument",
      type: ".msg",
    },
    {
      title: "UAT Scripts With Results",
      value: "uatScriptsWithResultsDocument",
      type: [".xlxs",".xls"],
    },
   
   
    { title: "Gate Form", value: "gateFormDocument", type: [".xlxs",".xls"] },
    {
      title: "Peer Review Checklist",
      value: "peerReviewchecklistDocument",
      type: [".xlxs",".xls"],
    },
    { title: "QA Sign Off", value: "qaSignOffDocument", type: ".msg" },
    { title: "Walk Through Video", value: "walkthroughVideo", type: [".mov",".mp4",".avi"] },
    { title: "KT Video", value: "ktVideo", type:  [".mov",".mp4",".avi"] },
  ];

  const [filteredDocumentAr, setFilteredDocumentAr] = React.useState(documentAr);

  React.useEffect(() => {
    setTotalItems(documentAr.length);
  }, []);

  // to upload a file
  
  const [fileUplaodState, setfileUplaodState] = useState(false);
  const [  currentlyUploading ,setCurrentlyUploading ] = useState(false)
  const [presentState, setPresentState ] = useState({})

  const uploadFile = async (file, name, title, originalFileName, extension) => {
    console.log("thisConsole",file, "file", name, "name", title, "title", originalFileName, 'orginalFileName');
    let counter = 0;
    console.log(originalFileName, "originalFileNamesfirst", originalFileNames)
    for (let i in originalFileNames) {
      
      if (originalFileNames[i].split(".")[0].split("~")[0] +"."+ originalFileNames[i].split(".")[originalFileNames[i].split(".").length-1] == originalFileName) {
        
        counter = counter + 1
      }
    }
    console.log(counter, "originalFileNameCounter")
    
    if (counter > 0) {
     originalFileName =  originalFileName.split(".")[0]+"~"+counter+"."+originalFileName.split(".")[1]
    }
    let fileName = originalFileName
    console.log(originalFileNames, 'originalFileNames')
    setCurrentlyUploading(true)
    setAzureFileNames({...azureFileNames, [name]: fileName });
    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = {
        
        blobHTTPHeaders: { blobContentType: file.type },
        concurrency: 25
      };
      const resp = await blockBlobClient.uploadBrowserData(file, options);

      console.log("blob upload response----", resp);
      setUploaded({ ...uploaded, [name]: true });
      setUploadedItems(uploadedItems + 1);
      setOriginalFileNames({ ...originalFileNames, [name]: originalFileName });
      //props.setUploadedFileToShowOutside(title)
      console.log(extension, "url idhar hai")
      let ar =  resp._response.request.url.split("?");
    let another = ar[0].split("/");
    let finalUrl = another[another.length - 1];
      // props.sendDocInfo(
      //   name,
      //   resp._response.request.url,
      //   title,
      //   uploadedItems + 1,
      //   extension
      // );

      setPresentState({
        ...presentState, [name] : finalUrl
      })


      setCurrentlyUploading(false)
    } catch (error) {
      setCurrentlyUploading(false)
      setCouldNotUpload({ ...couldNotUpload, [name]: true });
      setUploaded({...uploaded, [name] : false})
      
    }
  };
  console.log("Anshu file code",originalFileNames);

  // to delete a file

  const [deleteDocumentsLater, setDeleteDocumentsLater] = React.useState([]);

  const deleteThis = async (name) => {
    
    console.log(azureFileNames)
    let fileName = "1" + name;
    console.log(name, "azureFileName", azureFileNames);
    setPresentState({...presentState, [name] : ""})
    // if (azureFileNames[name]) {
      if (props.formType == "editBot") {
        
        // setDeleteDocumentsLater([
        //   ...deleteDocumentsLater,
        //   azureFileNames[name],
        // ]);
        console.log(uploaded, "uploadedBeforeDeleting")
         setUploaded({ ...uploaded, [name]: false });
         setUploadedItems(uploadedItems - 1);
         let azureFileNamesVar = {...azureFileNames};
         delete azureFileNamesVar[name];
         setAzureFileNames({...azureFileNamesVar});
         let previousFileTitle = null;
         // console.log(uploaded, "xadsda", name)
         for (let i in uploaded) {
           if (uploaded[i] == true && i != name) {
             previousFileTitle = i;
             break;
           }
         }
       //  props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);
      } else {
        let toDelete = azureFileNames[name]
        
         setUploaded({ ...uploaded, [name]: false });
         setUploadedItems(uploadedItems - 1);
         let azureFileNamesVar = {...azureFileNames};
         delete azureFileNamesVar[name];
         setAzureFileNames({...azureFileNamesVar});
         let previousFileTitle = null;
         // console.log(uploaded, "xadsda", name)
         for (let i in uploaded) {
           if (uploaded[i] == true && i != name) {
             previousFileTitle = i;
             break;
           }
         }
      //   props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);


     //   try {
        //  await containerClient.deleteBlob(toDelete);

        // }
        // catch(err) {
        //   console.log(err)
        // }
        
      }

     // alert("there");
     
   // }
  };



  const searchDocuments = (e) => {
      if (e.target.value.length == 0) {
        setFilteredDocumentAr(documentAr);
      } else {
        const options = {
          shouldSort: true,
          keys: [
            "title",
            "value",
            "type"
          ],
        };
       

        const fuse = new Fuse(documentAr, options);
        // Change the pattern
        const pattern = e.target.value;
        console.log("pattern  -----", pattern);
        let fuseResult = fuse.search(`${pattern}`);
      
        let filteredResult = [];
        console.log("fusee result  ----", fuseResult);
        for (let i in fuseResult) {
          filteredResult.push(fuseResult[i].item);
        }
        setFilteredDocumentAr(filteredResult);
      }
  }


  // const allDone = () => {
  //   const docURL=blobSasUrl1+"/"+props.documentFolderName;
  //   console.log("line number 329",docURL);
  //   localStorage.setItem("docURL", JSON.stringify(docURL));
  //   if (!currentlyUploading) {
    
    
    
  //   props.sendAllInfoAboutUploadModal(
  //     uploaded,
  //     totalItems,
  //     uploadedItems,
  //     originalFileNames,
  //     azureFileNames,
  //     deleteDocumentsLater,
  //     presentState
  //   );
  //   props.closeModal();
  //   }
  // };

  const allDone = () => {
    const docURL=blobSasUrl1+"/"+props.documentFolderName;
    console.log("line number 329",docURL);
    localStorage.setItem("docURL", JSON.stringify(originalFileNames));
    if (!currentlyUploading) {
    
    {/*{(props.softSkillDoc == 'softSkillDocState') ? null: (props.sendAllInfoAboutUploadModal(
      uploaded,
      totalItems,
      uploadedItems,
      originalFileNames,
      azureFileNames,
      deleteDocumentsLater,
      presentState
    ))}*/}
    props.sendAllInfoAboutUploadModal(
       uploaded,
       totalItems,
       uploadedItems,
       originalFileNames,
       azureFileNames,
     deleteDocumentsLater,
     presentState
     );
    props.closeModal();
    }
  };

  // to download a file
  // const downloadThis = async (e) => {
  //   let fileName = "1" + e.target.name;
  //   const blockBlobClient = containerClient.getBlobClient(fileName);
  //   const downloadBlockBlobResponse = await blockBlobClient.download(0);
  //   console.log(downloadBlockBlobResponse);
  // };



  return (
    <div className={styles.editModalWrapper}>
      <div className={styles.modalBox}>
        <div className={styles.modalHeader}>
          <p className={styles.content}>Document Uploader</p>
          <div className={styles.search}>
            <Icons name="searchGrayIcon" className={styles.searchIcon} />
            <input type="text" placeholder="Search" onChange = {searchDocuments}/>
          </div>
        </div>
        <div className={styles.modalBody}>
          <span className = {styles.formatType}>
            Upload files in the format of .pdf, .doc, .docx, .msg, .png, .jpeg, .jpg, .xls, .xlsx, .ppt, .pptx
          </span>
          <ul>
            {filteredDocumentAr.map((item, index) => (
              <li key={index} style={{position : "relative"}}>
                <div className={styles.left}>
                  <span>
                    {item.title}
                    {item.title == "SOP"  ?  <sup>*</sup> : null}
                   
                  </span>
                </div>
                <div className={styles.right}>
                  <UploadDocument
                    data={true}
                    title={item.title}
                    value={item.value}
                    fileType={ item.value == "walkthroughVideo" || item.value == "ktVideo" ? item.type :  [".pdf",".doc",".docx", ".msg", ".png", ".jpeg", ".jpg", ".xls", ".xlsx", ".ppt", ".pptx"]}
                    uploadFile={uploadFile}
                    uploaded={uploaded[item.value]}
                    couldNotUpload={couldNotUpload[item.value]}
                    originalFileName={originalFileNames[item.value]}
                    type="createBot"
                    specialCase = { item.value == "walkthroughVideo" || item.value == "ktVideo" ? true : false}
                    currentlyUploading = { currentlyUploading }
                  />
                  {
                    uploaded[item.value] ? 
                  
                  <div onClick={() => deleteThis(item.value)}>
                    <Icons name="deleteicon" className={styles.icon} />
                  </div> : null
                 }
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.left}>
            <span className={styles.countFilesSelected}>
              {`${uploadedItems}/${totalItems} files selected`}
            </span>
          </div>
          <div className={styles.right}>
            <div className={styles.combinedBtn}>
              <span
                className={styles.rowBtn}
                onClick={() => props.closeModal()}
              >
                Cancel
              </span>
              <span className={styles.exportListBtn}  onClick={() => allDone()}>
                <Icons name= "uploadicon"/>
                Upload files
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalExample;


